export function getPageBaseUrl(hostname: string | null): string {
  if (!hostname) return window.location.origin;
  if (hostname === "localhost") return "http://localhost:3002";
  return `https://${hostname}`;
}
